// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__27lqp","modalFooterButton":"ModalNotes_modalFooterButton__3eIf4"};